<template>
  <div class="flex flex-col gap-4 items-center bg-white justify-center p-8">
    <div class="flex flex-col gap-5 items-center justify-center">
      <div
        class="w-14 h-14 inline-flex items-center justify-center rounded-full bg-tertiary text-featured-icon-light-fg-gray"
        aria-hidden="true"
      >
        <slot name="icon">
          <AnnotationQuestion class="w-7 h-7" />
        </slot>
      </div>
      <div class="flex flex-col items-center justify-center gap-2 text-center">
        <span class="text-xl/tight font-semibold text-primary">
          {{ title || t("components.empty_states.no_results.title") }}
        </span>
        <span v-if="description" class="text-base text-tertiary">
          {{ description }}
        </span>
      </div>
    </div>
    <slot name="button" />
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { AnnotationQuestion } from "@/Icons";

const { t } = useI18n();

defineProps({
  title: { type: String, required: false },
  description: { type: String, required: false },
});
</script>
